"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_QUERY_LOCALES = exports.DEFAULT_COORDINATES = void 0;
const DEFAULT_COORDINATES = {
    latitude: 30.3076576, // defaults to Austin, TX
    longitude: -97.9205478, // defaults to Austin, TX
};
exports.DEFAULT_COORDINATES = DEFAULT_COORDINATES;
const DEFAULT_QUERY_LOCALES = {
    atlanta: {
        latitude: 33.7673401,
        longitude: -84.5025305,
    },
    chicago: {
        latitude: 41.8336152,
        longitude: -87.8967677,
    },
    connecticut: {
        latitude: 41.2982621,
        longitude: -73.007034,
    },
    dallas: {
        latitude: 32.8205561,
        longitude: -96.8967007,
    },
    detroit: {
        latitude: 42.3526815,
        longitude: -83.1816047,
    },
    dc: {
        latitude: 38.8937254,
        longitude: -77.0971474,
    },
    newyork: {
        latitude: 40.6973709,
        longitude: -74.144485,
    },
    sanantonio: {
        latitude: 29.458472,
        longitude: -98.6791819,
    },
    sanfrancisco: {
        latitude: 37.7576743,
        longitude: -122.5155383,
    },
    seattle: {
        latitude: 47.6086854,
        longitude: -122.422369,
    },
    houston: {
        latitude: 29.8170757,
        longitude: -95.5660968,
    },
    losangeles: {
        latitude: 34.0200393,
        longitude: -118.7413623,
    },
    indianapolis: {
        latitude: 39.779668,
        longitude: -86.2975541,
    },
    miami: {
        latitude: 25.7824017,
        longitude: -80.2707437,
    },
    nashville: {
        latitude: 36.1865276,
        longitude: -86.9500501,
    },
    neworleans: {
        latitude: 30.0328937,
        longitude: -90.0473688,
    },
    portland: {
        latitude: 45.5426842,
        longitude: -122.7369723,
    },
    wrexham: {
        latitude: 53.051084,
        longitude: -3.0088104,
    },
};
exports.DEFAULT_QUERY_LOCALES = DEFAULT_QUERY_LOCALES;
//# sourceMappingURL=data:application/json;base64,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